import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["input", "icon"]

  declare readonly inputTarget: HTMLInputElement
  declare readonly hasInputTarget: boolean
  declare readonly iconTarget: HTMLButtonElement
  declare readonly hasIconTarget: boolean

  connect() {
    this.updateVisibility()
  }

  get input(): HTMLInputElement | null {
    if (this.hasInputTarget) return this.inputTarget
    return this.element.querySelector("input")
  }

  updateVisibility() {
    const input = this.input
    if (!input || !this.hasIconTarget) return

    const isEmpty = input.value.length === 0
    
    if (isEmpty) {
      if (input.type !== "password") {
        input.type = "password"
        this.iconTarget.classList.add("opacity-40")
        this.iconTarget.classList.remove("opacity-100")
      }
    }
  }

  toggle(event: Event) {
    if (event) event.preventDefault()
    
    const input = this.input
    if (!input) return
    
    const isPassword = input.type === "password" || input.getAttribute("type") === "password"
    
    if (isPassword) {
      input.type = "text"
      input.setAttribute("type", "text")
      if (this.hasIconTarget) {
        this.iconTarget.classList.add("opacity-100")
        this.iconTarget.classList.remove("opacity-40")
      }
    } else {
      input.type = "password"
      input.setAttribute("type", "password")
      if (this.hasIconTarget) {
        this.iconTarget.classList.add("opacity-40")
        this.iconTarget.classList.remove("opacity-100")
      }
    }
  }
}
